import script from "./CreateNewPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateNewPassword.vue?vue&type=script&setup=true&lang=js"

import "./CreateNewPassword.vue?vue&type=style&index=0&id=45fb836c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45fb836c"]])

export default __exports__